/**
 * 违规词错误处理工具
 */

import { Message, MessageBox } from 'element-ui';

/**
 * 格式化违规词错误信息
 * @param {Object} errorData - 错误数据，包含 details 数组
 * @returns {string} 格式化后的错误信息 HTML
 */
export function formatBannedWordError(errorData) {
  if (!errorData || !errorData.details || !Array.isArray(errorData.details)) {
    return '提交的内容包含违规词，请修改后重新提交！';
  }

  const details = errorData.details;
  
  // 构建详细的错误信息 - 与系统风格统一
  let htmlContent = '<div style="padding: 8px 0; animation: fadeInUp 0.4s ease;">';
  
  // 标题部分 - 简洁大气
  htmlContent += '<div style="margin-bottom: 24px; text-align: center;">';
  htmlContent += '<div style="display: inline-flex; align-items: center; gap: 10px; margin-bottom: 10px;">';
  htmlContent += '<span style="font-size: 20px; line-height: 1; filter: drop-shadow(0 2px 4px rgba(239, 68, 68, 0.2));">⚠️</span>';
  htmlContent += '<span style="font-size: 16px; color: #1f2937; font-weight: 700; letter-spacing: 0.5px; background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">';
  htmlContent += '检测到违规词';
  htmlContent += '</span>';
  htmlContent += '</div>';
  htmlContent += '<p style="margin: 0; font-size: 13px; color: #6b7280; line-height: 1.6;">';
  htmlContent += '以下内容包含违规词，请修改后重新提交';
  htmlContent += '</p>';
  htmlContent += '</div>';
  
  // 违规词列表 - 每个来源一个卡片
  details.forEach((detail, index) => {
    const sourceName = detail.source || '未知来源';
    const words = detail.words || [];
    
    if (words.length > 0) {
      // 卡片容器 - 简洁设计
      htmlContent += `<div style="margin-bottom: 16px; background: linear-gradient(135deg, rgba(254, 242, 242, 0.6) 0%, rgba(255, 245, 245, 0.4) 100%); backdrop-filter: blur(8px); border-radius: 12px; padding: 16px; border: 1px solid rgba(252, 202, 202, 0.5); box-shadow: 0 2px 8px rgba(239, 68, 68, 0.08); transition: all 0.3s ease;" onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 12px rgba(239, 68, 68, 0.12)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(239, 68, 68, 0.08)'">`;
      
      // 来源标题
      htmlContent += `<div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">`;
      htmlContent += `<span style="width: 4px; height: 16px; background: linear-gradient(180deg, #ef4444 0%, #f87171 100%); border-radius: 2px; box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);"></span>`;
      htmlContent += `<span style="font-size: 14px; color: #1f2937; font-weight: 600;">${sourceName}</span>`;
      htmlContent += `</div>`;
      
      // 违规词标签
      htmlContent += `<div style="display: flex; flex-wrap: wrap; gap: 8px; padding-left: 12px;">`;
      
      words.forEach((word, wordIndex) => {
        htmlContent += `<span style="display: inline-flex; align-items: center; padding: 6px 14px; background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); color: #ffffff; border-radius: 6px; font-size: 13px; font-weight: 600; box-shadow: 0 2px 6px rgba(239, 68, 68, 0.25); letter-spacing: 0.3px; transition: all 0.3s ease; cursor: default; animation: scaleIn 0.3s ease ${wordIndex * 0.08}s both;" onmouseover="this.style.transform='scale(1.03) translateY(-1px)'; this.style.boxShadow='0 4px 10px rgba(239, 68, 68, 0.35)'" onmouseout="this.style.transform='scale(1) translateY(0)'; this.style.boxShadow='0 2px 6px rgba(239, 68, 68, 0.25)'">${word}</span>`;
      });
      
      htmlContent += `</div></div>`;
    }
  });
  
  // 底部提示
  htmlContent += '<div style="margin-top: 20px; padding: 12px 16px; background: linear-gradient(135deg, rgba(240, 249, 255, 0.7) 0%, rgba(224, 242, 254, 0.5) 100%); backdrop-filter: blur(8px); border-radius: 10px; border: 1px solid rgba(186, 230, 253, 0.5); display: flex; align-items: center; gap: 10px; box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08); transition: all 0.3s ease;" onmouseover="this.style.transform=\'translateY(-1px)\'; this.style.boxShadow=\'0 4px 12px rgba(59, 130, 246, 0.12)\'" onmouseout="this.style.transform=\'translateY(0)\'; this.style.boxShadow=\'0 2px 8px rgba(59, 130, 246, 0.08)\'">';
  htmlContent += '<span style="font-size: 16px; flex-shrink: 0; filter: drop-shadow(0 1px 2px rgba(3, 105, 161, 0.15));">💡</span>';
  htmlContent += '<span style="font-size: 14px; color: #0369a1; font-weight: 500; line-height: 1.5;">';
  htmlContent += '请删除或替换上述违规词后重新提交';
  htmlContent += '</span>';
  htmlContent += '</div>';
  
  // 添加动画样式
  htmlContent += '<style>';
  htmlContent += '@keyframes fadeInUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }';
  htmlContent += '@keyframes scaleIn { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }';
  htmlContent += '</style>';
  
  htmlContent += '</div>';
  
  return htmlContent;
}

/**
 * 显示违规词错误对话框
 * @param {Object} errorData - 错误数据
 * @param {Function} onConfirm - 确认回调
 */
export function showBannedWordDialog(errorData, onConfirm) {
  const htmlContent = formatBannedWordError(errorData);
  
  MessageBox.alert(htmlContent, '违规词检测', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '知道了',
    type: 'warning',
    customClass: 'banned-word-dialog',
    callback: () => {
      if (onConfirm && typeof onConfirm === 'function') {
        onConfirm();
      }
    }
  });
}

/**
 * 处理违规词错误（统一入口）
 * @param {Object} response - API 响应对象
 * @param {Function} onConfirm - 确认回调（可选）
 */
export function handleBannedWordError(response, onConfirm) {
  if (response && response.code === 1200 && response.data) {
    showBannedWordDialog(response.data, onConfirm);
    return true; // 表示已处理
  }
  return false; // 表示未处理
}

/**
 * 简化版：直接显示违规词错误消息
 * @param {Object} response - API 响应对象
 */
export function showBannedWordMessage(response) {
  if (response && response.code === 1200 && response.data) {
    const details = response.data.details || [];
    
    // 收集所有违规词
    const allWords = [];
    details.forEach(detail => {
      if (detail.words && Array.isArray(detail.words)) {
        allWords.push(...detail.words);
      }
    });
    
    if (allWords.length > 0) {
      const uniqueWords = [...new Set(allWords)];
      Message({
        message: `检测到违规词：${uniqueWords.join('、')}，请修改后重新提交`,
        type: 'warning',
        duration: 5000,
        showClose: true
      });
    } else {
      Message({
        message: response.message || '提交的内容包含违规词，请修改后重新提交！',
        type: 'warning',
        duration: 3000
      });
    }
    
    return true;
  }
  return false;
}
